import Component from './TodoList.component';
import { connect } from 'react-redux';
import fromState from '/b2b/common/state/selectors';

const mapStateToProps = state => ({
    allowedTodos: fromState.Dashboard.getAllowedTodos(state),
});

export default connect(mapStateToProps)(Component);
